export default __webpack_public_path__ + "static/media/0278c8dfc48a6950.d570f448f9f80b7791c6976e285304d9.svg";